import React from "react";
import AuthService from "./AuthService";
import AdminDashboard from "./Dashboards/AdminDashboard";
import StudentDashboard from "./Dashboards/StudentDashboard";
import TeacherDashboard from "./TeacherPortal/TeacherDashboard";
import ParentDashboard from "./Dashboards/ParentDashboard";
import HeadOfficeDashboard from "./Headmaster/HeadOfficeDashboard";

function Dashboard() {
  const user = AuthService.getCurrentUser();

  if (user?.user_type === "STUDENT") {
    return <StudentDashboard />;
  }

  if (user?.user_type === "TEACHER") {
    return <TeacherDashboard />;
  }

  if (user?.user_type === "PARENT") {
    return <ParentDashboard />;
  }

  if (
    user?.user_type === "HEADMASTER" ||
    user?.user_type === "HEADMASTER_OFFICE"
  ) {
    return <HeadOfficeDashboard />;
  }

  return <AdminDashboard />;
}

export default Dashboard;
